import styled, { css } from 'styled-components';

// Icons
import { CloseIcon } from '../../../../assets/icons/CloseIcon';
import { widthProps } from './types';

export const Container = styled.div<widthProps>`
  max-width: 95vw;
  width: ${({ width }) => (width ? width : '95vw')}rem;
  padding: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.modal};
  position: relative;
  ${({ type }) =>
    type === 'camera' &&
    css`
      background: none;
      border: none;
      box-shadow: none;
      padding: 0;
      /* El visor de cámara adopta la forma del fotograma, así que su ancho lo
         decide la cámara. Sin esto el modal conserva su ancho fijo y el botón
         de cerrar —anclado a la esquina del modal— queda flotando lejos del
         vídeo. */
      width: fit-content;
      & > header {
        position: absolute;
        z-index: 1;
        top: 8px;
        right: 8px;
      }
    `}
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const Button = styled.button`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  border: none;
  cursor: pointer;
  background: transparent;
  padding: 0;
`;

export const CloseIconImg = styled(CloseIcon)`
  padding: 4px;
  width: 2.2rem;
  height: 2.2rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  path {
    fill: ${({ theme }) => theme.colors.black};
  }
`;

export const Body = styled.div``;
